module.exports = require("@material-ui/icons/FormatListBulleted");